import Table from "src/components/Common/UI/DndTable/Table";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import React from "react";
import TableActionButtons from "src/components/Common/UI/DndTable/ActionButtons/TableActionButtons";
import { useBillingSummaryDataViewLogic } from "./hooks/useBillingSummaryDataViewLogic";
import PhoneLineBillingReport from "src/pages/Configuration/LinesAndNodesConfiguration/PhoneLine/PhoneLineBillingReport";
import ReportDownload from "src/components/Common/UI/ReportDownload/ReportDownload";


const BillingDataView = () => {
  const {
    summaryDetailsColumns,
    summaryDetailsData,
    summaryLinesColumns,
    summaryLinesData,
    loadingDone,
    setSelectedRowsOfTable,
    selectedRowsOfTable,
    actionEvent,
    modalEvent,
    closeActionModal,
    countLinesData,
    downloadAnchorRef,
    canDownloadCsv,
    canDownloadExcel,
    summaryLinesfooterVisibility
  } = useBillingSummaryDataViewLogic();

  const ActionButtons: React.FC = () => (
    <TableActionButtons event={actionEvent} canEdit={false} canDelete={false} showDetails={selectedRowsOfTable.length > 0} />
  );

  const DownloadComponent: React.FC = () => (
    <ReportDownload event={actionEvent} canDownloadCsv={canDownloadCsv} canDownloadExcel={canDownloadExcel} />            
  );

  return (
    <>
      <a ref={downloadAnchorRef} href="#" style={{ display: 'none' }} />
      {loadingDone && (
        <>
          <Table
            columns={summaryDetailsColumns}
            data={summaryDetailsData}
            defaultOrderByKeyFilter={"id"}
            showNumberOfRows={false}
            rowSelection={false}
            multipleRowSelection={false}
            actionRowId={"id"}
            debugMode={false}
            noDataFoundTitle="No Details yet"
            isChangeOrderOrVisibilityEnable={false}
            hiddenColumnsForUser={["deleted"]}
            textPosition="center"
            maxHeight="33rem"
            pagerVisibility={false}
          />
         
          <div className="mt-3">
            <Table
              columns={summaryLinesColumns}
              data={summaryLinesData}
              defaultOrderByKeyFilter={"id"}
              showNumberOfRows={true}
              rowSelection={true}
              setRowSelection={setSelectedRowsOfTable}
              multipleRowSelection={false}
              actionRowId={"phoneNumber"}
              debugMode={false}
              noDataFoundTitle="No Billing yet"
              isChangeOrderOrVisibilityEnable={false}
              ButtonsAreaLeft={ActionButtons}
              hiddenColumnsForUser={["deleted"]}
              textPosition="center"
              pagerVisibility={true}
              maxHeight="33rem"
              numberOfRows={countLinesData}
              numberOfRowsTitle="Εγγραφές"
              ButtonsAreaRight={DownloadComponent}
              footerVisibility={summaryLinesfooterVisibility}
            />
          </div>

          {modalEvent.action === "showDetails" && 
            <>
            {modalEvent.selectedRows && console.log("modalEvent.selectedRows", modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1)}
            
            <PhoneLineBillingReport handleCloseModal={closeActionModal} phoneNumber={modalEvent.selectedValue ? `${modalEvent.selectedValue}` : ""} />
            </>
          }
        </>
      )}

      {!loadingDone && <LoadingSpinner />}
    </>
  )
}

export default BillingDataView;

